import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OerebStateService {
  public hasData = new Subject<boolean>();
  hasData$ = this.hasData.asObservable();
}
